import React, { useMemo, useState, useEffect } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useProviderTagsContext } from '../../contexts/providerTags';
import { useProviderDetailsContext } from '../../contexts/providerDetails';
import {
  findProviderTags,
} from '../../api/ecDataQueryApi';
import IMG from '../img';
import config from '../../../preorder/configs/config';

const ProviderSideSectionContainer = styled.div`
  display: inline-block;
  width: 200px;
  vertical-align: top;
  text-align: left;
`;

const ProviderIcon = styled(IMG)`
  width: 200px;
  height: 200px;
  object-fit: contain;
  padding: 10px;
`;

const ProviderTagsContainer = styled.div`
  width: 200px;
  padding: 10px;
`;

const ParentTag = styled.div`
  position: relative;
  width: calc(100% - 20px);
  height: 35px;
  line-height: 35px;
  cursor: pointer;
  user-select: none;
  font-weight: bold;
  transition: height 0.3s;
  overflow: hidden;
  &:hover {
    opacity: 0.6;
  }
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #AAA;
    left: 0;
    bottom: 0;
  }
`;

const ChildTag = styled(ParentTag)`
  font-weight: normal;
  padding-left: 40px;
  &:before{
    content: '';
    position: absolute;
    left: 10px;
    top: 10px;
    width: 15px;
    height: 15px;
    background-color: #DDD;
  }
  ${(props) => (props.checked ? `
  &:before{
    background-color: grey;
    content: '\\2714\\0020';
    line-height: 15px;
    text-align: center;
    color: white;
  }
  ` : '')}
`;

export default ({
  provider,
}) => {
  const history = useHistory();

  const tagsFromQuery = useMemo(() => {
    try {
      return _.get(
        queryString.parse(history.location.search, { arrayFormat: 'index' }),
        ['tags'],
        ''
      ).split(',')
        .reduce((result, current) => ({
          ...result,
          ...(current ? { [current]: true } : {}),
        }), {});
    } catch (error) {
      console.error(error);
    }
    return {};
  }, [history.location.search]);

  const {
    providerTags: providerTagsCache,
    addProviderTags,
  } = useProviderTagsContext();
  const {
    providerDetails: providerDetailsCache,
  } = useProviderDetailsContext();

  const [selectedParentTag, setSelectedParentTag] = useState(null);
  const [checkedTags, setCheckedTags] = useState(tagsFromQuery);

  useEffect(() => {
    const queryObject = queryString.parse(window.location.search, { arrayFormat: 'index' });
    const searchTags = Object.keys(checkedTags).filter((tag) => checkedTags[tag]);
    if (searchTags.length > 0) queryObject.tags = searchTags.join(',');
    else delete queryObject.tags;
    history.push(`?${queryString.stringify(queryObject)}`);
  }, [history, checkedTags]);

  useEffect(() => {
    if (!provider || providerTagsCache[provider]) return;
    (async () => {
      try {
        const providerTagsData = await findProviderTags(provider);
        const providerTagDictionary = {};
        const providerTags = [];

        providerTagsData.forEach((row) => {
          const {
            key,
          } = row;
          providerTagDictionary[key] = row;
        });
        providerTagsData.forEach((row) => {
          const {
            parent_tag,
          } = row;
          if (!parent_tag) {
            providerTags.push(row);
          } else {
            const parentTag = providerTagDictionary[parent_tag];
            if (parentTag) {
              parentTag.children = [
                ...(parentTag.children || []),
                row,
              ];
            }
          }
        });

        addProviderTags(provider, providerTags);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [provider]); //eslint-disable-line

  return (
    <ProviderSideSectionContainer>
      <ProviderIcon
        src={_.get(providerDetailsCache, [provider, 'icon'], null)}
        onError={(e) => {
          e.currentTarget.src = `${config.RESOURCE_URI}logo.png`;
        }}
      />
      {
        _.get(providerTagsCache, [provider], null) && (
          <ProviderTagsContainer>
            {
              (providerTagsCache[provider] || []).map((row) => {
                const {
                  key,
                  value,
                  children,
                } = row;
                const childrenStyle = selectedParentTag === key ? {} : { height: 0 };
                return (
                  <>
                    <ParentTag
                      key={key}
                      onClick={() => setSelectedParentTag(key === selectedParentTag ? null : key)}
                    >
                      {value}
                    </ParentTag>
                    {
                      (children || []).map((child) => {
                        const {
                          key: childKey,
                          value: childValue,
                        } = child;
                        return (
                          <ChildTag
                            key={childKey}
                            style={childrenStyle}
                            checked={checkedTags[childKey]}
                            onClick={() => setCheckedTags({
                              ...checkedTags,
                              [childKey]: !checkedTags[childKey],
                            })}
                          >
                            {childValue}
                          </ChildTag>

                        );
                      })
                    }
                  </>
                );
              })
            }
          </ProviderTagsContainer>
        )
      }
    </ProviderSideSectionContainer>
  );
};
